import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "control-menu__unit"
}
const _hoisted_2 = {
  key: 1,
  class: "control-menu__link",
  "data-test-id": "downloading-audio",
  disabled: ""
}

import type { BookNativeStorageView } from '@/models/book.native.storage.view'


export default /*@__PURE__*/_defineComponent({
  __name: 'NativeStorageDownloadButton',
  props: {
    nativeStorageView: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.nativeStorageView?.supportsAudioDownloads)
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
        (__props.nativeStorageView.audioDownloadState === 'noDownload')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "control-menu__link",
              "data-test-id": "download-audio",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.nativeStorageView.downloadAudio && __props.nativeStorageView.downloadAudio(...args)))
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("span", { class: "control-menu__icon iconfont idownload" }, null, -1),
              _createElementVNode("span", null, "Download Audio", -1)
            ]))]))
          : (__props.nativeStorageView.audioDownloadState === 'inProgress')
            ? (_openBlock(), _createElementBlock("button", _hoisted_2, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "control-menu__icon iconfont idownload" }, null, -1),
                _createElementVNode("span", null, "Downloading Audio...", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "control-menu__link",
                "data-test-id": "delete-audio",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (__props.nativeStorageView.deleteAudioDownload && __props.nativeStorageView.deleteAudioDownload(...args)))
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("span", { class: "control-menu__icon iconfont idelete" }, null, -1),
                _createElementVNode("span", null, "Remove Audio Download", -1)
              ]))]))
      ]))
    : _createCommentVNode("", true)
}
}

})